import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import { hasuraClient, nestClient } from "./apolloClient";
import { ApolloProvider } from "react-apollo";
import { ApolloProvider as ApolloHooksProvider } from "@apollo/react-hooks";
import ModalContextProvider from "./context/ModalContext";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <ApolloHooksProvider client={nestClient}>
      <ApolloProvider client={hasuraClient}>
        <ModalContextProvider>
          <App />
        </ModalContextProvider>
      </ApolloProvider>
    </ApolloHooksProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
